function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 6,
  fill: "#2CD2CF"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/greenDot.6ea36c48.svg";
export { SvgComponent as ReactComponent };